/* global PhotoSwipe, PhotoSwipeLightbox, Flickity */

var imageExtension = /\.(avif|gif|jpe?g|png|webp)$/i;

function isImageLink(link) {
  var href;
  var path;
  if (!link || link.closest('figcaption')) {
    return false;
  }
  href = link.getAttribute('href');
  if (!href) {
    return false;
  }
  try {
    path = new URL(href, window.location.href).pathname;
  } catch (e) {
    path = e ? '' : href;
  }
  if (!path) {
    return false;
  }
  return imageExtension.test(path);
}

function groupRoot(link) {
  return link.closest('#album, #simplegallery, .slider') || link.closest('main') || document.body;
}

function groupOf(link) {
  var root = groupRoot(link);
  return Array.prototype.filter.call(root.querySelectorAll('a[href]'), function (candidate) {
    return isImageLink(candidate) && groupRoot(candidate) === root;
  });
}

function sizeOf(link) {
  var width = parseInt(link.getAttribute('data-pswp-width'), 10);
  var height = parseInt(link.getAttribute('data-pswp-height'), 10);
  var img;
  if (width && height) {
    return Promise.resolve({ width: width, height: height });
  }
  img = link.querySelector('img');
  if (img) {
    width = parseInt(img.getAttribute('width'), 10) || img.naturalWidth;
    height = parseInt(img.getAttribute('height'), 10) || img.naturalHeight;
    if (width && height) {
      return Promise.resolve({ width: width, height: height });
    }
  }
  return new Promise(function (resolve) {
    var probe = new Image();
    probe.onload = function () {
      resolve({ width: probe.naturalWidth, height: probe.naturalHeight });
    };
    probe.onerror = function () {
      resolve({ width: 0, height: 0 });
    };
    probe.src = link.href;
  });
}

function captionOf(link) {
  var figure = link.closest('figure');
  var caption;
  if (!figure) {
    return '';
  }
  caption = figure.querySelector('figcaption');
  return caption ? caption.innerHTML : '';
}

function slideOf(link) {
  return sizeOf(link).then(function (size) {
    var img = link.querySelector('img');
    return {
      src: link.href,
      width: size.width,
      height: size.height,
      alt: img ? (img.getAttribute('alt') || '') : '',
      caption: captionOf(link)
    };
  });
}

var lightbox = new PhotoSwipeLightbox({
  pswpModule: PhotoSwipe
});

lightbox.on('uiRegister', function () {
  lightbox.pswp.ui.registerElement({
    name: 'caption',
    order: 9,
    isButton: false,
    appendTo: 'root',
    onInit: function (el, pswp) {
      pswp.on('change', function () {
        var caption = (pswp.currSlide && pswp.currSlide.data.caption) || '';
        el.innerHTML = caption;
        el.hidden = !caption;
      });
    }
  });
});

lightbox.init();

function openAt(link) {
  var group = groupOf(link);
  var index = group.indexOf(link);
  if (index < 0) {
    return;
  }
  Promise.all(group.map(slideOf)).then(function (slides) {
    if (!slides[index] || !slides[index].width || !slides[index].height) {
      return;
    }
    lightbox.loadAndOpen(index, slides);
  });
}

document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href]');
  if (!link || !isImageLink(link) || link.closest('.slider')) {
    return;
  }
  event.preventDefault();
  openAt(link);
});

document.querySelectorAll('.slider').forEach(function (slider) {
  var flkty = Flickity.data(slider);
  if (!flkty) {
    return;
  }
  flkty.on('staticClick', function (event) {
    var cell = arguments[2];
    var link = cell && cell.querySelector('a[href]');
    if (!link || !isImageLink(link)) {
      return;
    }
    event.preventDefault();
    openAt(link);
  });
});

document.querySelectorAll('.slider a[href]').forEach(function (link) {
  if (!isImageLink(link)) {
    return;
  }
  link.addEventListener('click', function (event) {
    event.preventDefault();
    if (event.detail === 0) {
      openAt(link);
    }
  });
});
